import { initializeDBL } from 'dibs-buyer-layout/src/entries/index';
import { buyRespRootQuery } from '../../queries/buyRespRoot';
import { BuySharedLayout } from '../../buy/BuySharedLayout';
import { createEntry } from '../createEntry';

import { defaultReducers } from '../../reducers/reducerUtils';

const options = {
    reducers: {
        ...defaultReducers,
    },
};

initializeDBL(options).then(({ store }) => {
    createEntry({
        Container: BuySharedLayout,
        store,
        query: buyRespRootQuery,
    });
});
